import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef,
  OnChanges, OnDestroy, OnInit, ViewEncapsulation, Input, Output, EventEmitter,
  SimpleChanges, HostListener } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { TableIndexService } from "./table-index.service";
import { LoadingService } from "../loading/loading.service";
import { ChangePageService } from "../change-page/change-page.service";
import { GridOptions } from "ag-grid-community";
import { DatosGenericosService } from "../../../@core/mock/datosGenericos/datosGenericos.service";

@Component({
  selector: 'table-index',
  templateUrl: './table-index.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./table-index.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class TableIndexComponent implements OnInit, AfterViewInit, OnDestroy, OnChanges {
  startDate: string = '';
  endDate: string = '';
  dataToSearch: string = '';
  paramsFind: any[] = [];
  params: any[] = [];
  columnDefs: any;
  dataFillTable: any = [];
  rowData: any;
  showTable: boolean = false;
  @Input() tableData: any;
  @Input() heightDiv: any;
  @Input() borderCard: boolean = true;
  @Input() loadTable: number = 0;
  /**
   * Opt-in (por defecto false = comportamiento histórico). Con true:
   * - columnas al ancho de su contenido (sin textos truncados) y, si sobra espacio, se reparten el ancho;
   *   si no cabe, scroll horizontal;
   * - el alto se ajusta a las filas mostradas (usa `heightDiv` como máximo) para no dejar hueco en blanco;
   * - celdas centradas verticalmente.
   * También se puede activar con `tableData.fitContent = true`.
   */
  @Input() fitContent: boolean = false;
  @Output() optionsTableClicked = new EventEmitter<any>();
  @Output() valueEditData = new EventEmitter<any>();
  @Output() cellClicked = new EventEmitter<any>();
  gridOptions: GridOptions;
  private gridApi;
  private gridColumnApi;
  private components;
  private localeText;
  page: string = 'Página';
  more: string = 'Más';
  to: string = 'a';
  of: string = 'de';
  next: string = 'Siguiente';
  last: string = 'Último';
  first: string = 'Primero';
  previous: string = 'Anterior';
  loadingOoo: string = 'Cargando ...';
  noRowsToShow: string = 'Sin información';
  lastFilterselected: number = -1;
  heightTable: any;
  showTwoColumns: boolean = false;
  showOneColumn: boolean = false;
  showTwoRows: boolean = false;
  selectedRows: any[];
  showAlertMessage: boolean = false;
  messTextAlert: string = '';
  messTypeAlert: string = 'primary';
  typeSelection: string = 'single';
  showCheckButton: boolean = false;
  slideConfig = {'slidesToShow': 4, 'slidesToScroll': 4};
  isMobile: boolean = false;
  cardSelectedRows: Set<number> = new Set();
  mobileDataLoaded = false;
  /** Paginación en servidor: activa con tableData.dataAPIS.serverSide = true; espera {data, total}. */
  serverSide: boolean = false;
  serverPage: number = 1;
  serverPerPage: number = 25;
  serverTotal: number = 0;
  serverPerPageOptions: number[] = [25, 50, 100, 200];
  constructor(
    private tableIndexService: TableIndexService,
    private loading: LoadingService,
    private changePage: ChangePageService,
    private cdr: ChangeDetectorRef,
    private elementRef: ElementRef,
    private generalData: DatosGenericosService,
    private breakpointObserver: BreakpointObserver,
    private sanitizer: DomSanitizer,
  ) {
    this.gridOptions = <GridOptions>{
      pagination: true,
      headerHeight: 40.58,
      floatingFiltersHeight: 35,
      rowHeight: 40.58,
      defaultColDef: {}  // Inicializa defaultColDef como un objeto vacío
    };
    this.gridOptions.defaultColDef.resizable = true;
    this.gridOptions.defaultColDef.sortable = true;
    this.components = {numericCellEditor: getNumericCellEditor()};
    this.tableIndexService.observerShowAlert.subscribe(
      (res: { message: string, type: string, reload: boolean }) => {
        this.showAlert(res.message, res.type);
        if (res.reload) {
          this.reloadData();
        }
      });
    this.localeText = {
      page: this.page,
      more: this.more,
      to: this.to,
      of: this.of,
      next: this.next,
      last: this.last,
      first: this.first,
      previous: this.previous,
      loadingOoo: this.loadingOoo,
      noRowsToShow: this.noRowsToShow,
    };
    this.tableIndexService.reziseColumns.subscribe(res => {
      setTimeout(() => {
        this.resizingColumns();
      }, 200);
    });
    this.generalData.reloadTable.subscribe(() => {
      this.reloadData();
    });
  }
  ngOnInit() {
    this.isMobile = typeof window !== 'undefined' && window.innerWidth <= 768;
    this.breakpointObserver.observe([Breakpoints.Handset, '(max-width: 768px)']).subscribe(result => {
      this.isMobile = result.matches;
      this.cdr.markForCheck();
    });
    this.changePage.showChangePage.next(false);
    if (this.tableData.filtersParamns) {
      if (this.tableData.filtersParamns.length < 4) {
        this.showTwoColumns = true;
        this.heightTable = 'calc(' + this.heightDiv + ' - 90px)';
      } else {
        this.showTwoRows = true;
        this.heightTable = 'calc(' + this.heightDiv + ' - 150px)';
      }
    } else {
      this.showOneColumn = true;
      this.heightTable = 'calc(' + this.heightDiv + ' - 90px)';
    }
    if (this.tableData.calendarItem) {
      this.startDate = this.tableData.calendarItem.startDate;
      this.endDate = this.tableData.calendarItem.endDate;
    }
    this.serverSide = !!(this.tableData.dataAPIS && this.tableData.dataAPIS.serverSide);
    if (this.tableData.dataAPIS && this.tableData.dataAPIS.perPage) {
      this.serverPerPage = this.tableData.dataAPIS.perPage;
    }
    if (this.serverSide) {
      this.heightTable = 'calc(' + this.heightTable + ' - 40px)';
    }
    this.columnDefs = this.tableData.columnDefs;
    this.gridOptions.columnDefs = this.tableData.columnDefs;
    for (let i = 0; i < this.tableData.optionsTable.length; i++) {
      if (this.tableData.optionsTable[i].select === 'multiple') {
        this.typeSelection = 'multiple';
        this.showCheckButton = true;
      }
    }
    this.columnDefs[0].checkboxSelection = this.showCheckButton;
    this.gridOptions.rowSelection = this.typeSelection;
    this.showTable = true;
  }
  ngAfterViewInit() {
    this.iniSlickJs();
    if (this.isMobile && this.showTable) {
      this.loadDataForMobile();
    }
  }
  private iniSlickJs() {
    const htmlScriptElement = document.createElement('script');
    htmlScriptElement.src = 'https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.9.0/slick.min.js';
    this.elementRef.nativeElement.appendChild(htmlScriptElement);
  }
  ngOnDestroy() {
    this.changePage.showChangePage.next(true);
  }
  private lastEndpoint: string = null;
  ngOnChanges(changes: SimpleChanges) {
    if (changes.loadTable && changes.loadTable.previousValue != changes.loadTable.currentValue) {
      if (this.serverSide && this.tableData.dataAPIS.endPoint !== this.lastEndpoint) {
        this.serverPage = 1;
      }
      this.lastEndpoint = this.tableData.dataAPIS.endPoint;
      this.reloadData();
    }
  }
  onCellEditingStopped(event) {
    this.valueEditData.emit(event);
  }
  buttonClicked(value) {
    this.selectedRows = this.gridApi.getSelectedRows();
    const data = {'btn': value, 'rows': this.selectedRows};
    console.log(value);
    if (value.select !== 'null') {
      if (value.select === 'single') {
        if (this.selectedRows.length === 1) {
          this.optionsTableClicked.emit(data);
          setTimeout(() => {
            //this.gridOptions.api.deselectAll();
          }, 1000);
        } else if (this.selectedRows.length < 1) {
          this.showAlert('Se requiere que seleccione un registro', 'warning');
        } else {
          this.showAlert('Solo permite la selección de un registro', 'warning');
        }
      }
      if (value.select === 'multiple') {
        if (this.selectedRows.length < 1) {
          this.showAlert('Se requiere que seleccione un registro', 'warning');
        } else {
          this.optionsTableClicked.emit(data);
          setTimeout(() => {
            this.gridOptions.api.deselectAll();
          }, 1000);
        }
      }
    } else {
      this.optionsTableClicked.emit(data);
      setTimeout(() => {
        this.gridOptions.api.deselectAll();
      }, 1000);
    }
  }
  showAlert(message, type) {
    this.messTextAlert = '';
    this.messTypeAlert = '';
    this.messTextAlert = message;
    this.showAlertMessage = true;
    this.messTypeAlert = type;
    setTimeout(() => {
      this.closeAlert();
    }, 3000);
  }
  closeAlert() {
    this.showAlertMessage = false;
    this.cdr.detectChanges();
  }
  makeProcess(value) {
    if (value) this.reloadData();
  }
  dataSearch(value) {
    this.dataToSearch = value;
    if (this.serverSide) {
      this.serverPage = 1;
      this.reloadData();
      return;
    }
    this.gridOptions.api.setQuickFilter(value);
  }
  onGridReady(params) {
    const DOMAIN = this.tableData.dataAPIS.DOMAIN;
    const endpoint = this.tableData.dataAPIS.endPoint;
    this.setTableParams();
    if (this.tableData.filtersParamns) {
      this.tableData.filtersParamns.forEach(val => {
        if (val.selected) {
          this.params.push({param: val.paramn, val: val.value});
        }
      });
    }
    this.gridColumnApi = params.columnApi;
    this.gridApi = params.api;
    this.tableIndexService.dataTableIndex(DOMAIN, endpoint, this.params).subscribe(res => {
      this.dataFillTable = this.normalizeResponse(res);
      if (this.gridOptions.api) {
        this.gridOptions.api.setRowData(this.dataFillTable);
        setTimeout(() => {
          this.resizingColumns();
          this.loading.showLoading.next(false);
        }, 300);
      } else {
        this.loading.showLoading.next(false);
      }
      this.cdr.markForCheck();
    }, err => {
      this.dataFillTable = [];
      if (this.gridOptions.api) {
        this.gridOptions.api.setRowData([]);
      }
      this.loading.showLoading.next(false);
      console.log('error', err);
    });
  }

  /** Carga datos para la vista móvil (tarjetas) sin usar el grid */
  loadDataForMobile(): void {
    const DOMAIN = this.tableData.dataAPIS.DOMAIN;
    const endpoint = this.tableData.dataAPIS.endPoint;
    this.setTableParams();
    if (this.tableData.filtersParamns) {
      this.tableData.filtersParamns.forEach(val => {
        if (val.selected) {
          this.params.push({param: val.paramn, val: val.value});
        }
      });
    }
    this.loading.showLoading.next(true);
    this.tableIndexService.dataTableIndex(DOMAIN, endpoint, this.params).subscribe(res => {
      this.dataFillTable = this.normalizeResponse(res);
      this.mobileDataLoaded = true;
      this.loading.showLoading.next(false);
      this.cdr.markForCheck();
    }, err => {
      this.dataFillTable = [];
      this.loading.showLoading.next(false);
      this.cdr.markForCheck();
      console.log('error', err);
    });
  }
  onCellClicked(event) {
    this.cellClicked.emit(event);
  }
  get isFitContent(): boolean {
    return !!(this.fitContent || (this.tableData && this.tableData.fitContent));
  }

  /** Alto del nb-card: en modo fitContent crece con el contenido (heightDiv queda como tope del grid). */
  get cardHeight(): any {
    return this.isFitContent ? 'auto' : this.heightDiv;
  }

  /** Alto del grid: en modo fitContent, el de las filas mostradas sin pasar del alto original. */
  get gridHeight(): string {
    if (!this.isFitContent) return this.heightTable;
    const rows = this.fitRowCount;
    const header = this.gridOptions.headerHeight || 40;
    const row = this.gridOptions.rowHeight || 40;
    const pagingPanel = this.serverSide ? 0 : 34;
    // Mínimo para que el mensaje "Sin información" / "Cargando" quepa con aire; +18 por un posible scroll horizontal.
    const content = Math.max(rows, 3) * row + header + pagingPanel + 18;
    return `min(${this.heightTable}, ${Math.ceil(content)}px)`;
  }

  /** Ajuste de columnas del modo fitContent: al contenido y, si sobra espacio, repartido. */
  private fitColumnsToContent(): void {
    const columnApi = this.gridColumnApi || (this.gridOptions && this.gridOptions.columnApi);
    if (!this.gridApi || !columnApi) return;
    columnApi.autoSizeAllColumns(false);
    const viewport: HTMLElement = this.elementRef.nativeElement.querySelector('.ag-center-cols-viewport')
      || this.elementRef.nativeElement.querySelector('.ag-body-viewport');
    const available = viewport ? viewport.clientWidth : 0;
    const used = (columnApi.getAllDisplayedColumns() || []).reduce((sum: number, c: any) => sum + c.getActualWidth(), 0);
    if (available && used < available) {
      this.gridApi.sizeColumnsToFit();
    }
  }

  resizingColumns() {
    if (this.gridApi && this.isFitContent) {
      this.fitColumnsToContent();
      return;
    }
    if (this.gridApi) {
      if (this.tableData.autoSizeColumns) {
        this.gridOptions.defaultColDef = {resizable: true};
        const allColumnIds = [];
        this.gridOptions.columnApi.getAllColumns().forEach((column: any) => {
          allColumnIds.push(column.colId);
        });
        this.gridOptions.columnApi.autoSizeColumns(allColumnIds);
      } else {
        this.gridApi.sizeColumnsToFit();
      }
    }
  }
  startDateChange(value) {
    this.startDate = value;
    this.cdr.detectChanges();
  }
  endDateChange(value) {
    this.endDate = value;
    this.cdr.detectChanges();
  }
  reloadData() {
    this.dataFillTable = [];
    this.mobileDataLoaded = false;
    this.loading.showLoading.next(true);
    if (this.isMobile) {
      this.loadDataForMobile();
      return;
    }
    const DOMAIN = this.tableData.dataAPIS.DOMAIN;
    const endpoint = this.tableData.dataAPIS.endPoint;
    this.setTableParams();
    if (this.tableData.filtersParamns) {
      this.tableData.filtersParamns.forEach(val => {
        if (val.selected) {
          this.params.push({param: val.paramn, val: true});
        }
      });
    }
    this.tableIndexService.dataTableIndex(DOMAIN, endpoint, this.params).subscribe(res => {
      this.dataFillTable = this.normalizeResponse(res);
      if (this.gridOptions.api) {
        this.gridOptions.api.setRowData(this.dataFillTable);
      }
      if (this.isFitContent) {
        setTimeout(() => this.resizingColumns(), 60);
      }
      this.loading.showLoading.next(false);
      this.cdr.markForCheck();
    }, err => {
      this.dataFillTable = [];
      if (this.gridOptions.api) {
        this.gridOptions.api.setRowData([]);
      }
      this.loading.showLoading.next(false);
      this.cdr.markForCheck();
      console.log('error', err);
    });
    setTimeout(() => {
      this.resizingColumns();
    }, 300);
  }
  addParams(option, e) {
    if (this.lastFilterselected !== e) {
      this.lastFilterselected = e;
      this.setTableParams();
      this.tableData.filtersParamns.forEach(val => {
        val.selected = false;
      });
      this.tableData.filtersParamns[e].selected = true;
      this.params.push({param: option.paramn, val: option.value});
    } else {
      this.tableData.filtersParamns[e].selected = false;
      this.setTableParams();
      this.lastFilterselected = -1;
    }
    this.reloadData();
  }
  setTableParams() {
    this.params = [];
    if (this.tableData.calendarItem) {
      const aS = this.startDate.split('-');
      const nDS = new Date(parseInt(aS[0], 10), (parseInt(aS[1], 10) - 1), parseInt(aS[2], 10)).getTime();
      const aE = this.endDate.split('-');
      const nDE = new Date(parseInt(aE[0], 10), (parseInt(aE[1], 10) - 1), (parseInt(aE[2], 10) + 1)).getTime();
      this.params.push({param: 'di', val: nDS});
      this.params.push({param: 'de', val: nDE});
    }
    if (this.tableData.searchData) {
      this.params.push({param: 'sd', val: this.dataToSearch});
    }
    if (this.serverSide) {
      this.params.push({param: 'page', val: this.serverPage});
      this.params.push({param: 'per_page', val: this.serverPerPage});
    }
  }

  /** Acepta un arreglo plano, `{data: []}` o `{code, data: {data: [], total}}` y actualiza el total en modo servidor. */
  private normalizeResponse(res: any): any[] {
    const rows = this.extractRows(res);
    this.fitRowCount = rows.length;
    return rows;
  }

  /** Filas de la última respuesta (fitContent): evita que el alto salte a mínimo mientras se recarga. */
  private fitRowCount = 0;

  private extractRows(res: any): any[] {
    let body: any = res;
    if (body && typeof body === 'object' && !Array.isArray(body) && 'code' in body && 'data' in body) {
      body = body.data;
    }
    if (Array.isArray(body)) {
      if (this.serverSide) this.serverTotal = body.length;
      return body;
    }
    if (body && Array.isArray(body.data)) {
      this.serverTotal = typeof body.total === 'number' ? body.total : body.data.length;
      if (body.per_page) this.serverPerPage = body.per_page;
      if (body.page) this.serverPage = body.page;
      return body.data;
    }
    return [];
  }

  get serverPages(): number {
    return Math.max(1, Math.ceil(this.serverTotal / this.serverPerPage));
  }

  get serverFrom(): number {
    return this.serverTotal === 0 ? 0 : (this.serverPage - 1) * this.serverPerPage + 1;
  }

  get serverTo(): number {
    return Math.min(this.serverTotal, this.serverPage * this.serverPerPage);
  }

  goToServerPage(page: number): void {
    if (page < 1 || page > this.serverPages || page === this.serverPage) return;
    this.serverPage = page;
    this.reloadData();
  }

  changeServerPerPage(value: any): void {
    this.serverPerPage = parseInt(value, 10) || 25;
    this.serverPage = 1;
    this.reloadData();
  }
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    if (this.gridApi) {
      setTimeout(() => {
        this.resizingColumns();
      }, 200);
    }
  }

  /** Columnas para vista en tarjetas (móvil): excluye checkbox */
  getColumnsForCards(): { field: string; headerName: string }[] {
    if (!this.columnDefs) return [];
    return this.columnDefs
      .filter((c: any) => !c.checkboxSelection && c.field)
      .map((c: any) => ({ field: c.field, headerName: c.headerName || c.field }));
  }

  getRowValue(row: any, col: { field: string }): any {
    const v = row && row[col.field];
    return v != null ? v : '—';
  }

  private mobileCardsSource: any[] = null;
  private mobileCardsCache: { row: any, cells: { label: string, html: SafeHtml }[] }[] = [];

  /**
   * Tarjetas de la vista móvil con el mismo contenido que las celdas de escritorio:
   * aplica valueGetter → valueFormatter → cellRenderer (si es función que devuelve texto/HTML) de cada columna;
   * si la columna no define ninguno (o falla), muestra el valor crudo como antes.
   */
  get mobileCards(): { row: any, cells: { label: string, html: SafeHtml }[] }[] {
    if (this.mobileCardsSource !== this.dataFillTable) {
      this.mobileCardsSource = this.dataFillTable;
      // La primera columna recibe checkboxSelection en modo multiselección pero sigue siendo una columna de datos.
      const cols = (this.columnDefs || []).filter((c: any) => (c.field || c.valueGetter) && !c.hide);
      this.mobileCardsCache = (Array.isArray(this.dataFillTable) ? this.dataFillTable : []).map((row: any, index: number) => ({
        row,
        // Mismo HTML que ag-grid inserta en escritorio (los renderers son código de la app; los valores crudos se escapan).
        cells: cols.map((c: any) => ({
          label: c.headerName || c.field || '',
          html: this.sanitizer.bypassSecurityTrustHtml(this.renderMobileCell(row, c, index)),
        })),
      }));
    }
    return this.mobileCardsCache;
  }

  private renderMobileCell(row: any, colDef: any, rowIndex: number): string {
    const raw = row ? row[colDef.field] : undefined;
    const params: any = {
      value: raw, data: row, colDef, column: null, node: {data: row, rowIndex}, rowIndex,
      api: this.gridApi || null, columnApi: this.gridColumnApi || null, context: this.gridOptions && this.gridOptions.context,
      getValue: () => raw, setValue: () => {}, eGridCell: null, refreshCell: () => {},
    };
    try {
      if (typeof colDef.valueGetter === 'function') {
        params.value = colDef.valueGetter(params);
      }
      if (typeof colDef.valueFormatter === 'function') {
        params.valueFormatted = colDef.valueFormatter(params);
      }
      if (typeof colDef.cellRenderer === 'function') {
        const out = colDef.cellRenderer(params);
        if (typeof out === 'string' || typeof out === 'number') {
          return String(out).trim() !== '' ? String(out) : '—';
        }
        if (out && (out as any).outerHTML) {
          return (out as any).outerHTML;
        }
      }
      const text = params.valueFormatted != null ? params.valueFormatted : params.value;
      return text != null && String(text) !== '' ? this.escapeHtml(String(text)) : '—';
    } catch (e) {
      return raw != null && raw !== '' ? this.escapeHtml(String(raw)) : '—';
    }
  }

  private escapeHtml(value: string): string {
    return value.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  toggleCardSelection(row: any, index: number): void {
    if (this.cardSelectedRows.has(index)) {
      this.cardSelectedRows.delete(index);
    } else {
      this.cardSelectedRows.add(index);
    }
    this.cdr.markForCheck();
  }

  isCardSelected(index: number): boolean {
    return this.cardSelectedRows.has(index);
  }

  getCardSelectedRows(): any[] {
    return this.dataFillTable.filter((_: any, i: number) => this.cardSelectedRows.has(i));
  }

  onCardOptionClick(option: any, row: any): void {
    const data = { btn: option, rows: [row] };
    this.optionsTableClicked.emit(data);
    this.cdr.markForCheck();
  }

  onCardOptionClickFromBar(option: any): void {
    const rows = this.getCardSelectedRows();
    const data = { btn: option, rows };
    if (option.select === 'single' && rows.length !== 1) {
      this.showAlert(rows.length === 0 ? 'Se requiere que seleccione un registro' : 'Solo permite la selección de un registro', 'warning');
      return;
    }
    if (option.select === 'multiple' && rows.length < 1) {
      this.showAlert('Se requiere que seleccione un registro', 'warning');
      return;
    }
    this.optionsTableClicked.emit(data);
    this.cardSelectedRows.clear();
    this.cdr.markForCheck();
  }

  onCardClicked(row: any): void {
    this.cellClicked.emit({ data: row });
  }
}
function getNumericCellEditor() {
  function filterFloat(evt, input) {
    const key = evt.keyCode;
    const chark = String.fromCharCode(key);
    const tempValue = input.value + chark;
    if (key >= 48 && key <= 57) {
      if (filter(tempValue) === false) {
        return false;
      } else {
        return true;
      }
    } else {
      if (key === 8 || key === 13 || key === 0) {
        return true;
      } else if (key === 46) {
        if (filter(tempValue) === false) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    }
  }

  function filter(__val__) {
    const preg = /^([0-9]+\.?[0-9]{0,2})$/;
    if (preg.test(__val__) === true) {
      return true;
    } else {
      return false;
    }
  }

  function isCharNumeric(charStr) {
    return !!/^(\d{1}\.)?(\d+\.?)+(,\d{2})?$/.test(charStr);
  }

  function isKeyPressedNumeric(event) {
    const charCode = getCharCodeFromEvent(event);
    const charStr = String.fromCharCode(charCode);
    return isCharNumeric(charStr);
  }

  function getCharCodeFromEvent(event) {
    event = event || window.event;
    return typeof event.which === 'undefined' ? event.keyCode : event.which;
  }

  function NumericCellEditor() {
  }

  NumericCellEditor.prototype.init = function (params) {
    this.focusAfterAttached = params.cellStartedEdit;
    this.eInput = document.createElement('input');
    this.eInput.style.width = '100%';
    this.eInput.style.height = '100%';
    this.eInput.value = isCharNumeric(params.charPress) ? params.charPress : params.value;
    const that = this;
    this.eInput.addEventListener('keypress', function (event) {

      if (!filterFloat(event, this)) {
        that.eInput.focus();
        if (event.preventDefault) event.preventDefault();
      }
    });
  };
  NumericCellEditor.prototype.getGui = function () {
    return this.eInput;
  };
  NumericCellEditor.prototype.afterGuiAttached = function () {
    if (this.focusAfterAttached) {
      this.eInput.focus();
      this.eInput.select();
    }
  };
  NumericCellEditor.prototype.isCancelBeforeStart = function () {
    return this.cancelBeforeStart;
  };
  NumericCellEditor.prototype.isCancelAfterEnd = function () {
  };
  NumericCellEditor.prototype.getValue = function () {
    return this.eInput.value;
  };
  NumericCellEditor.prototype.focusIn = function () {
    const eInput = this.getGui();
    eInput.focus();
    eInput.select();
    // console.log('NumericCellEditor.focusIn()');
  };
  NumericCellEditor.prototype.focusOut = function () {
    // console.log('NumericCellEditor.focusOut()');
  };
  return NumericCellEditor;
}
